/**
 * O foco está num campo que consome o teclado?
 *
 * Atalhos de editor (S, Del, I/O, Ctrl+Z) precisam sair do caminho quando a pessoa está
 * digitando — mas nem todo `<input>` digita. Um SLIDER tem foco de input e nenhum undo
 * próprio: tratar os dois igual fazia Ctrl+Z não responder depois de ajustar a
 * opacidade, sem nada na tela explicando por quê.
 *
 * A regra é o que o campo faz com a tecla, não a tag dele.
 */
const TEXTUAL_INPUT_TYPES = new Set([
  'text', 'search', 'email', 'password', 'url', 'tel', 'number', 'date', 'time',
  'datetime-local', 'month', 'week',
])

export function isTextEntry(target: EventTarget | null): boolean {
  const element = target as HTMLElement | null
  if (!element) return false
  if (element.isContentEditable) return true
  if (element.tagName === 'TEXTAREA') return true
  if (element.tagName !== 'INPUT') return false
  // Um input sem `type` é do tipo text.
  const type = (element as HTMLInputElement).type || 'text'
  return TEXTUAL_INPUT_TYPES.has(type)
}
